<template>
  <div class="main main-really-raised w-50 ml-auto mr-auto mt-0">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="card card-signup no-shadow mt-0">
            <div
              class="card-header card-header-primary negative blue-grad w-50"
            >
              <h4 class="card-title">
                {{ $t("message.notifications.notifications_title") }}
              </h4>
            </div>
            <div class="card-body px-3">
              <div v-if="notifications.length > 0">
                <b-table
                  id="notifications-table"
                  responsive
                  :items="notifications"
                  :fields="fields"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :tbody-tr-class="rowClass"
                >
                  <template v-slot:cell(Type)="data">
                    <div
                      style="cursort: pointer"
                      @click="openNotification(data.item, data.index)"
                    >
                      {{ notificationTitle(data.item) }}
                    </div>
                  </template>
                  <template v-slot:cell()="data">
                    <div
                      style="cursort: pointer"
                      @click="openNotification(data.item, data.index)"
                    >
                      {{ data.value }}
                    </div>
                  </template>
                  <template v-slot:cell(CreationDate)="data">
                    <div
                      style="cursort: pointer"
                      @click="openNotification(data.item, data.index)"
                    >
                      {{ momentum(data.value) }}
                    </div>
                  </template>
                  <template v-slot:cell(is_read)="data">
                    <button
                      @click="toggleRead(data.item, data.index)"
                      class="btn btn-sm btn-link mx-0 px-0 py-0 pt-1 position-relative"
                      style="width: 20px; height: 20px"
                    >
                      <span
                        style="position: absolute; left: 0; top: 2px"
                        v-show="data.item.Archived === false"
                        ><i
                          :class="['fas', 'text-primary', 'fa-circle', 'mx-2']"
                        ></i
                      ></span>
                      <span
                        style="position: absolute; left: 0; top: 2px"
                        v-show="data.item.Archived === true"
                        ><i
                          :class="['far', 'text-primary', 'fa-circle', 'mx-2']"
                        ></i
                      ></span>
                    </button>
                  </template>

                  <template v-slot:cell(remove)="data">
                    <button
                      class="btn btn-sm btn-link text-danger p-0"
                      @click="deleteNotification(data.item)"
                    >
                      <i class="fa fa-trash"></i>
                    </button>
                  </template>
                </b-table>
                <!-- <div class="clearfix">
									<div class="d-flex align-items-center float-right">
										<div class="text-nowrap">{{$t('message.notifications.perPage')}}</div>
										<select v-model=perPage class="form-control ml-2">
											<option value="10">10</option>
											<option value="10">50</option>
											<option value="10">100</option>
										</select>
									</div>
								</div> -->
                <!-- <div class="d-flex justify-content-center">
									<b-pagination
								      v-model="currentPage"
								      :total-rows="notifications.length"
								      :per-page="perPage"
								      aria-controls="orders-table"
								    ></b-pagination>
								</div> -->
              </div>
              <div class="text-muted text-center p-4" v-else>
                {{ $t("message.notifications.empty") }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      id="modal-notification"
      hide-footer
      :title="notificationTitle(current)"
    >
      <div class="text">
        {{ notificationText(current) }}
        <div class="buttons btn-group">
          <router-link
            :to="{ name: 'user-profile', params: { id: current.CreatorCode } }"
            class="btn btn-sm btn-outline-info"
          >
            {{ $t("message.notifications.contragent") }}
          </router-link>
          <router-link
            v-if="show_offer_button"
            :to="{
              name: 'offer-single',
              params: { id: current.ContractId, oid: current.ObjectId },
            }"
            class="mx-2 btn btn-sm btn-outline-warning"
          >
            {{ $t("message.notifications.offer") }}
          </router-link>
          <router-link
            v-if="show_courier_button"
            :to="{
              name: 'courier-single',
              params: { id: current.ContractId, oid: current.ObjectId },
            }"
            class="mx-2 btn btn-sm btn-outline-warning"
          >
            {{ $t("message.notifications.courieroffer") }}
          </router-link>
          <router-link
            v-if="show_contract_button"
            :to="{
              name: 'contracts-single',
              params: { id: current.ContractId },
            }"
            class="mx-2 btn btn-sm btn-outline-success"
            >{{ $t("message.notifications.contract") }}</router-link
          >
          <router-link
            v-if="show_registrations_button"
            :to="{ name: 'admin-registrations' }"
            class="mx-2 btn btn-sm btn-outline-success"
            >{{ $t("message.admin.registrations") }}</router-link
          >
          <router-link
            v-if="show_insu_req_button"
            :to="{
              name: 'view-insurance-request',
              params: { id: current.ObjectId },
            }"
            class="mx-2 btn btn-sm btn-outline-success"
            >{{ $t("message.notifications.insurance_request") }}</router-link
          >
          <router-link
            v-if="show_form_m_button"
            :to="{
              name: 'document-viewer',
              params: {
                type: 'form_m',
                id: current.ContractId
              },
            }"
            class="mx-2 btn btn-sm btn-outline-success"
            >{{ $t("message.contracts.form_m") }}</router-link
          >
        </div>
      </div>
      <div class="text-muted mt-3">
        {{ momentum(current.CreationDate) }}
      </div>
    </b-modal>
  </div>
</template>
<script>
import moment from "moment";
export default {
  data() {
    return {
      currentPage: 1,
      perPage: 10,
      fields: [
        {
          key: "is_read",
          label: "",
          sortable: false,
        },
        {
          key: "CreatorName",
          label: this.$t("message.notifications.CreatorName"),
          sortable: true,
        },
        {
          key: "Type",
          label: this.$t("message.notifications.Title"),
          sortable: true,
        },
        {
          key: "CreationDate",
          label: this.$t("message.notifications.CreationDate"),
          sortable: true,
        },
        {
          key: "remove",
          label: "",
          sortable: false,
        },
      ],
      notifications: [],
      current: {},
    };
  },
  mounted() {
    if (!this.$store.state.auth) this.$router.push({ name: "sign-in" });
    this.load();
  },
  computed: {
    show_offer_button() {
      const offerButtonTypes = [1, 2, 3, 4, 5]
      if (offerButtonTypes.includes(Number(this.current.Type)))
        return true;
      return false;
    },
    show_courier_button() {
      const courierButtonTypes = [6, 7, 8]
      if (courierButtonTypes.includes(Number(this.current.Type)))
        return true;
      return false;
    },
    show_registrations_button() {
      if (Number(this.current.Type) == 16) return true;
      return false;
    },
    show_contract_button() {
      const contractButtonTypes = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 33]
      if (contractButtonTypes.includes(Number(this.current.Type)))
        return true;
      return false;
    },
    show_insu_req_button() {
      const insuranceRequestButtonTypes = [18, 19, 20, 21, 22]
      if (insuranceRequestButtonTypes.includes(Number(this.current.Type)))
        return true;
      return false;
    },
    show_form_m_button() {
      const formMButtonTypes = [30, 31, 32]
      if (formMButtonTypes.includes(Number(this.current.Type)))
        return true;
      return false;
    },
  },
  methods: {
    rowClass(item, type) {
      if (!item || type !== "row") return;
      if (item.Archived === false) return "table-success font-weight-bold";
    },
    isRead(notification) {
      return notification.Archived === true;
    },
    momentum(date) {
      return moment(date).format("DD.MM.Y HH:mm");
    },
    load() {
      axios.get(window.base + "/notification/all").then((response) => {
        this.notifications = response.data;
      });
    },
    openNotification(notification, index) {
      axios
        .get(window.base + "/notification/read?id=" + notification.Id)
        .then((response) => {
          this.current = response.data;
          this.$set(this.notifications[index], "Archived", true);
          this.$bvModal.show("modal-notification");
        });
    },
    toggleRead(notification, index) {
      if (notification.Archived == true) {
        axios
          .get(window.base + "/notification/unread?id=" + notification.Id)
          .then(() => {
            this.$set(this.notifications[index], "Archived", false);
          });
      } else {
        axios
          .get(window.base + "/notification/read?id=" + notification.Id)
          .then(() => {
            this.$set(this.notifications[index], "Archived", true);
          });
      }
    },
    deleteNotification(notification) {
      axios
        .get(window.base + "/notification/delete?id=" + notification.Id)
        .then(() => {
          this.load();
        });
    },
    notificationTitle(notification) {
      return this.$t(`message.notifications.type_${notification.Type}_title`).replace("{{ObjectId}}", notification.ContractId);
    },
    notificationText(notification) {
      let text = this.$t(`message.notifications.type_${notification.Type}_text`);
      text = text.replace("{{OrgName}}", notification.OrgName);
      text = text.replace("{{CreatorName}}", notification.CreatorName);
      return text.replace("{{ContractId}}", notification.ContractId);
    },
  },
};
</script>
<style>
tr td {
  cursor: pointer !important;
}
</style>
